import { client } from "utils";

export const getStatusTypeRequest = () => client.get("status-type");
